import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface CancelOrderResponse {
  cancelOrder: {
    id: GQL_ID
    status: number
  }
}

interface CancelOrderVariables {
  order_id: GQL_ID
}

export const GQL_MUTATION_CANCEL_ORDER = gql`
  mutation cancelOrder($order_id: ID!) {
    cancelOrder(order_id: $order_id) {
      id
      status
    }
  }
`

export const useMutateCancelOrder = () =>
  useMutation<CancelOrderResponse, CancelOrderVariables>(
    GQL_MUTATION_CANCEL_ORDER,
  )
